import { render } from "./5.OtherProducts.vue?vue&type=template&id=26188461&scoped=true"
import script from "./5.OtherProducts.vue?vue&type=script&lang=js"
export * from "./5.OtherProducts.vue?vue&type=script&lang=js"

import "./5.OtherProducts.vue?vue&type=style&index=0&id=26188461&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26188461"]])

export default __exports__